<template>
  <div class="container">
    <h1 class="h4 mt-5">Pagina niet gevonden
      <br>
      <span class="text-secondary">404</span>
    </h1>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    mounted: function () {
      setTimeout(() => { // Give some time advantage to the logger in the index.js in case of router redirects to this component.
        this.$log.error('The component 404 NotFound was reached.');
      }, 50);
    }
  }
</script>

<style scoped>
  h1 {text-align: center}
  h1 span {
    font-size: 5rem;
    font-weight: bold;
    /*color: ;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue